/** @format */

export type UseCarouselDots = {
  getActiveDotIndex: (currentSlide: number, totalPhotos: number) => number;
  shouldShowDots: (totalPhotos: number) => boolean;
  getDotsCount: (totalPhotos: number) => number;
};

export const useCarouselDots = (): UseCarouselDots => {
  const getActiveDotIndex = (currentSlide: number, totalPhotos: number): number => {
    if (totalPhotos <= 2) {
      return currentSlide - 1;
    } else {
      if (currentSlide === 1) {
        return 0;
      } else if (currentSlide === totalPhotos) {
        return 2;
      } else {
        return 1;
      }
    }
  };

  const shouldShowDots = (totalPhotos: number): boolean => {
    return totalPhotos > 1;
  };

  const getDotsCount = (totalPhotos: number): number => {
    if (totalPhotos <= 1) return 0;
    if (totalPhotos === 2) return 2;
    return 3;
  };

  return { getActiveDotIndex, shouldShowDots, getDotsCount };
};
